<h2 mat-dialog-title>{{info.actionText}} </h2>
<mat-dialog-content>
    {{info.content}}
</mat-dialog-content>
<mat-dialog-actions>
    <button class="me-5" (click)="close()" color="primary" mat-stroked-button>
        {{info.cancelText ? info.cancelText : 'COMMON.CANCEL' | translate}}
    </button>

    <button color="primary" (click)="save()" mat-flat-button>
        {{info.confirmText ? info.confirmText : 'COMMON.CONFIRMED' | translate}}
    </button>
</mat-dialog-actions>